export const formatNumberWithCommas = (number: string | number) => {
  if (typeof number === "number") number = number.toString();
  return number.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
